"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Property = void 0;
const value_1 = require("./value");
class Property extends value_1.Value {
    constructor(name, description, schema, initializer) {
        super(name, description, schema);
        this.serializedName = name;
        this.applyWithExclusions(["schema"], initializer);
    }
}
exports.Property = Property;
//# sourceMappingURL=property.js.map